import { createFeatureSelector, createSelector } from "@ngrx/store";

import { ShadeFinderState } from "../reducers/shade-finder-state";
import { shadeFinderFeatureKey } from "../reducers/shade-finder.reducer";

export const selectShadeFinderState = createFeatureSelector<ShadeFinderState>(
    shadeFinderFeatureKey,
);

export const selectShadeFinderConfiguration = createSelector(
    selectShadeFinderState,
    (featureState: ShadeFinderState) => featureState.shadeFinderConfig,
);

export const selectIsApprovalState = createSelector(
    selectShadeFinderState,
    (shadeFinderState: ShadeFinderState) => shadeFinderState.isApproval,
);

export const selectModalStatusState = createSelector(
    selectShadeFinderState,
    (shadeFinderState: ShadeFinderState) => shadeFinderState.modalStatus,
);

export const selectCameraDimensionState = createSelector(
    selectShadeFinderState,
    (shadeFinderState: ShadeFinderState) => shadeFinderState.cameraDimension,
);

export const selectSdkErrorState = createSelector(
    selectShadeFinderState,
    (shadeFinderState: ShadeFinderState) => shadeFinderState.sdkError,
);

export const shadeFinderModalConfiguration = createSelector(
    selectShadeFinderState,
    (featureState: ShadeFinderState) => ({
        sdkError: featureState.sdkError,
        modalStatus: featureState.modalStatus,
        isApproval: featureState.isApproval,
    }),
);
